export default {
  esg_dashboard: {
    title: '대시보드',
  },
  improvement_plans: {
    title: '개선 계획',
  },
  question_group_section: {
    card_title: '미응답 조사표/서베이',
    list_header_buyer_company_name: '평가 의뢰 기업',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: '응답 기한',
    list_header_status: '상태',
    number_of_answered_label: '응답 수',
    // number_of_answered_unit: '',
    number_of_answered: '진척률： {answered}/{total}',
    status_re_answer_request: '철회 의뢰 중',
    answer: '응답하기',
    withdrawn: '반려 완료',
    // no_survey_response_requests_text_1:  '',
    // contact: '',
    // no_survey_response_requests_text_2: '',
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: '평가 의뢰 기업',
    list_header_question: '조사표',
    list_header_create_at: '발행일',
    list_header_deadline: '유효기한',
    list_header_status: '상태',
    limit_one_year: '발행일로부터 1년간',
    esg_score: 'ESG 스코어',
    esg_rating: 'ESG 등급',
    detail: '상세',
  },
  faq_section: {
    card_title: '자주 하는 질문',
    faq_why_request: {
      question:
        '거래처로부터 ASUENE ESG의 응답을 의뢰 받았는데요. 어째서 이런 의뢰가 온 걸까요?',
      answer:
        '최근 대기업을 중심으로 지속가능한 조달에 어떻게 대응하고 있는지가 주목받고 있고, 공급망의 환경과 인권을 포함한 ESG 관련 사회적 요구 사항을 고려하여 사업을 이끌어 갈 필요성이 대두되고 있습니다. 이러한 대응에 있어서 대기업은 자사의 대응뿐만 아니라 ‘자사의 거래처에 대해서도 ESG 대응을 실시하고 있는지’를 파악할 필요가 있습니다.',
    },
    faq_what_benefit: {
      question: 'ASUENE ESG에 응답하면 어떤 이점이 있습니까?',
      answer:
        'ASUENE ESG를 받는 것에는 아래의 3가지 이점이 있습니다.\n1) ESG에 관한 귀사의 강점과 개선점을 파악할 수 있습니다.\n2) 귀사의 ESG 평가를 동종 업계의 타사와 비교할 수 있습니다.\n3) ESG 평가 결과를 외부에 공개하면 ESG에 대한 대응 내용을 홍보할 수 있습니다.',
    },
    list: '목록보기',
  },
  contact_section: {
    card_title: '문의하기',
    description:
      '조사표/서베이 내용이나 응답 방법에 궁금한 점이 있을 때는 언제든지 문의해 주세요. \n더 구체적인 ESG 대응 개선・밀착 지원을 원하는 분은 별도로 전문 컨설턴트의 지원을 받을 수도 있습니다.',
    inquiry: '문의하기',
  },
}
